import { render, staticRenderFns } from "./quantu1.vue?vue&type=template&id=66d11f36&scoped=true&"
import script from "./quantu1.vue?vue&type=script&lang=js&"
export * from "./quantu1.vue?vue&type=script&lang=js&"
import style0 from "./quantu1.vue?vue&type=style&index=0&id=66d11f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d11f36",
  null
  
)

export default component.exports